import {
  Component,
  OnDestroy,
  OnInit,
  EventEmitter,
  Input,
  Output,
  LOCALE_ID,
  ViewChild,
} from '@angular/core';
import { BalanceService } from '../../services/api/balance.service';
import { BaseService } from 'src/app/services/base.service';
import { Subject, takeUntil } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseCustomType } from '../../types/response/response.type';
import { BalanceResponseType } from '../../types/response/balance-response.type';
import { PossibleIncomeResponseType } from '../../types/response/possible-income-response.type';
import { ORDER_ANALYTICS } from 'src/app/constants/endpoint.const';
import {
  LocaleConfig,
  DaterangepickerDirective,
} from 'ngx-daterangepicker-material';
import * as moment from 'moment';
import localeId from '@angular/common/locales/id';
import id from '@angular/common/locales/id';
import { registerLocaleData } from '@angular/common';
import { MaintenanceComponent } from 'src/app/modules/shared/components/maintenance/maintenance.component';
import { ProfileService } from 'src/app/services/profile.service';
import { ProfileResponseType } from 'src/app/types/response/profile-response.type';
import { BuatRekeningComponent } from './components/modal-buat-rekening/buat-rek.component';
import { BankService } from 'src/app/services/api/bank.service';
import { BankModel } from 'src/app/models/bank.model';
import { BuatPinComponent } from './components/modal-buat-pin/buat-pin.component';
import { ModalTarikKomisiComponent } from './components/modal-tarik-komisi/modal-tarik-kom.component';
import { wdListModel } from 'src/app/models/withdrawl-list.model';
import { BlokReqWDComponent } from 'src/app/modules/shared/components/modal-blocked-request-wd/blocked-req-wd.component';
import { LocaleConfigDate, rangesDateDashboard } from 'src/app/constants/date-config.const';
import { NzMessageService } from 'ng-zorro-antd/message';
import { OrderAnalyticsResponseType } from 'src/app/types/response/order-analytics-response.type';
import {
  DashboardCard,
  DashboardFilter,
  DashboardFilterList,
  DashboardRanges,
  DashboardSelectedDate,
  DateRangeChangeEvent,
  OrderStatus,
} from 'src/app/models/dashboard.model';
import { cards, orderStatuses } from 'src/app/constants/dashboard.const';

registerLocaleData(localeId);

@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [{ provide: LOCALE_ID, useValue: 'id' }],
})
export class DashboardComponent implements OnInit, OnDestroy {
  @ViewChild(DaterangepickerDirective, { static: false })
  datePicker!: DaterangepickerDirective;
  destroy$ = new Subject();
  profile!: ProfileResponseType;
  bankList: BankModel[] = [];
  @Input() wdList: wdListModel[] = [];
  balance: BalanceResponseType = {
    balance: 0,
    commission: 0,
  };

  possibleIncome: PossibleIncomeResponseType = {
    possible_income: 0,
  };

  startDate: string = '';
  endDate: string = '';

  selected: DashboardSelectedDate = {
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
  };

  ranges: any = rangesDateDashboard;

  invalidDates: moment.Moment[] = [
    moment().add(2, 'days'),
    moment().add(3, 'days'),
    moment().add(5, 'days'),
  ];

  isInvalidDate = (m: moment.Moment): boolean => {
    return this.invalidDates.some((d) => d.isSame(m, 'day'));
  };

  @Input() filter: DashboardFilter = {
    start_date: moment().startOf('month').format('YYYY-MM-DD'),
    end_date: moment().endOf('month').format('YYYY-MM-DD'),
  };

  @Input() filterList: DashboardFilterList = {
    start_date: '2019-01-01',
    end_date: moment().format('YYYY-MM-DD'),
    type: 'balance',
  };

  @Output() filterResult = new EventEmitter<DashboardFilter>();
  setlocale: LocaleConfig = LocaleConfigDate
  keepCalendarOpeningWithRange: boolean;
  pinStatus: boolean = false;
  modalBlock: boolean = false;
  loading: boolean = true;
  isSandBoxMode: boolean = localStorage.getItem('mode') === 'sandbox';
  packageStatus: number = 0;

  orderStatuses: OrderStatus[] = orderStatuses;
  cards: DashboardCard[] = cards;
  startTour: boolean = false;

  constructor(
    private balanceService: BalanceService,
    private modalService: NgbModal,
    public baseService: BaseService,
    private bankService: BankService,
    private message: NzMessageService,
    private profileService: ProfileService
  ) {
    this.keepCalendarOpeningWithRange = true;
  }

  ngOnInit(): void {
    this.packageStatus = this.profileService.getRoLevel();
    this.profileService.getRoLevel$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((level) => {
        this.packageStatus = level;
      });
    this.getPossibleIncome();
    this.getBankList();
    this.getDataOrders();
    setTimeout(() => this.loading = false, 1000);
  }

  handleGuide() {
    this.startTour = true;
  }

  handleStartTour(e: boolean) {
    this.startTour = e;
  }

  openDatepicker(): void {
    this.datePicker.open();
  }

  onChangeDate(e: DateRangeChangeEvent | null): void {
    if (!e || !e.startDate || !e.endDate) return;

    this.filter.start_date = e.startDate.format('YYYY-MM-DD');
    this.filter.end_date = e.endDate.format('YYYY-MM-DD');

    this.filterResult.emit(this.filter);
    this.getDataOrders();
  }

  getPossibleIncome(): void {
    this.balanceService.possibleIncome()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: ResponseCustomType<PossibleIncomeResponseType>) => this.possibleIncome = res.data);
  }

  handleWithdrawalCommission(): void {
    if (!this.pinStatus) {
      this.handleNoPIN();
    } else if (!this.bankList || this.bankList.length === 0) {
      this.handleNoRek();
    } else {
      this.handleTarikKomisi();
    }
  }

  handleTarikKomisi(): void {
    const filterList: DashboardFilterList = {
      start_date: '2019-01-01',
      end_date: moment().format('YYYY-MM-DD'),
      type: 'commission',
    };

    this.balanceService.withdrawlList(filterList)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: ResponseCustomType<wdListModel[]>) => {
        const hasBlockedRequest = res.data?.some((item: wdListModel) =>
          (item.type === 'commission' && item.status === 'request') || item.status === 'review'
        );

        this.modalService.open(hasBlockedRequest ? BlokReqWDComponent : ModalTarikKomisiComponent, {
          backdrop: 'static',
          centered: true,
        });
      });
  }

  handleNoRek(): void {
    this.modalService.open(BuatRekeningComponent, { backdrop: 'static', centered: true });
  }

  handleNoPIN(): void {
    this.modalService.open(BuatPinComponent, { backdrop: 'static', centered: true });
  }

  maintenance(): void {
    this.modalService.open(MaintenanceComponent, { backdrop: 'static', centered: true });
  }

  getBankList(): void {
    this.bankService.bankList()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: ResponseCustomType<BankModel[]>) => this.bankList = res.data);
  }

  getDataOrders(): void {
    const params = {
      include: 'cards',
      filter_type: 'custom',
      start_date: this.filter.start_date,
      end_date: this.filter.end_date,
    };

    this.baseService.getData(ORDER_ANALYTICS, params).subscribe({
      next: (res: ResponseCustomType<OrderAnalyticsResponseType>) => {
        const cardsData = res.data?.cards;
        if (!cardsData) return;

        const {
          total_shipment,
          delivered_package,
          total_cashback_delivered,
          on_process_delivery,
          total_cashback_delivery,
          returned,
          on_process_return,
        } = cardsData;

        if (this.cards[0]) {
          this.cards[0].value = total_shipment;
        }

        if (this.cards[1]) {
          this.cards[1].value = delivered_package;
          if (this.cards[1].footer) {
            this.cards[1].footer.value = total_cashback_delivered;
            this.cards[1].footer.isCurrency = true;
          }
        }

        if (this.cards[2]) {
          this.cards[2].value = on_process_delivery;
          if (this.cards[2].footer) {
            this.cards[2].footer.value = total_cashback_delivery;
            this.cards[2].footer.isCurrency = true;
          }
        }

        if (this.cards[3]) {
          this.cards[3].value = returned;
          if (this.cards[3].footer) {
            this.cards[3].footer.value = on_process_return;
          }
        }
      },
      error: () => {
        this.message.error('Failed to load shipping performance data');
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
